import React, { useEffect, useRef, useState } from "react";

const PropertyInfoPanel = ({ addressData }) => {
  const streetViewRef = useRef(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!addressData || !window.google || !streetViewRef.current) return;

    const { formatted, lat, lng } = addressData;

    try {
      new window.google.maps.StreetViewPanorama(streetViewRef.current, {
        position: { lat, lng },
        pov: { heading: 0, pitch: 0 },
        zoom: 1,
      });
      setError(false);
    } catch (err) {
      console.error(err);
      setError(true);
    }
  }, [addressData]);

  if (!addressData) {
    return (
      <div className="text-sm text-muted-foreground">
        Search an address to view property information.
      </div>
    );
  }

  const zillowUrl = `https://www.zillow.com/homes/${encodeURIComponent(
    addressData.formatted
  )}_rb/`;

  return (
    <div className="space-y-4">

      <h3 className="text-base font-semibold" style={{ color: "var(--cb-navy)" }}>
        {addressData.formatted}
      </h3>

      <div className="h-[380px] w-full bg-gray-100 rounded-lg overflow-hidden">
        {!error ? (
          <div ref={streetViewRef} style={{ width: "100%", height: "100%" }} />
        ) : (
          <div className="flex items-center justify-center h-full text-gray-500">
            <div className="text-center">
              <div className="text-4xl mb-2">⚠️</div>
              <p>Failed to load Street View</p>
            </div>
          </div>
        )}
      </div>

      <a
        href={zillowUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-white font-medium shadow hover:opacity-90"
      >
        View on Zillow
      </a>

    </div>
  );
};

export default PropertyInfoPanel;


